import {
    currentSelectedImageSelector,
    currentImageFieldSelector,
    clearState
} from 'features/image_library/imageLibrarySlice'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

const useImageFromLibrary = (fieldName, setValue) => {
    const imageUrlFromLibrary = useSelector(currentSelectedImageSelector)
    const imageField = useSelector(currentImageFieldSelector)
    const dispatch = useDispatch()

    useEffect(() => {
        if (imageField === fieldName && imageUrlFromLibrary) {
            setValue(imageUrlFromLibrary)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageUrlFromLibrary, imageField])

    // Clear state in store when component is unmounted
    useEffect(() => () => {
        dispatch(clearState())
    }, [dispatch])
}

export default useImageFromLibrary
